export default {
  每月: "每月",
  季度: "季度",
  全年: "全年",
  計算: "計算",
  新公司計算器: "成立公司費用計算器",
  "2020所得補充稅模擬計算": "2021 - 2022年度所得補充稅模擬計算",
  "2021個人職業所得稅計算器": "2023個人職業所得稅計算器",
  計算年度: "計算年度",
  "65歲以下": "65歲以下",
  "2021年度剛滿65歲": "2022年度剛滿65歲",
  "65歲以上/殘疾人士": "65歲以上/殘疾人士",
  "A.每月總收益（包括不課稅收益）": "A. 每月總收益（包括不課稅收益）",
  "A.季度總收益（包括不課稅收益）": "A.季度總收益（包括不課稅收益） ",
  "A.全年總收益（包括不課稅收益）": "A.全年總收益（包括不課稅收益） ",
  "B.不屬課稅收益": "B.不屬課稅收益",
  "C.固定扣除，相當於對B項扣減後之工作收益之25%":
    "C.固定扣除，相當於對B項扣減後之工作收益之 25%",
  "D.每月可課稅收益": "D.每月可課稅收益(A-B-C)",
  "D.季度可課稅收益": "D.季度可課稅收益(A-B-C)",
  "D.全年可課稅收益": "D.全年可課稅收益(A-B-C)",
  出生年份: "出生年份",
  時間: "時間",
  註冊資本: "註冊資本",
  由: "由",
  至: "至",
  稅率: "稅率",
  可課稅收益: "可課稅收益",
  該級可課稅收益: "該級可課稅收益",
  該級稅款: "該級稅款",
  累計稅款: "累計稅款",
  根據法定稅率計出之每月稅款: "E.根據法定稅率計出之每月稅款",
  根據法定稅率計出之季度稅款: "E.根據法定稅率計出之季度稅款",
  根據法定稅率計出之全年稅款: "E.根據法定稅率計出之全年稅款",
  "根據有關年度財政預算案對職業稅稅額之30%扣減優惠":
    "F.根據有關年度財政預算案對職業稅稅額之30%扣減優惠",
  每月應繳職業稅稅款: "G.每月應繳職業稅稅款",
  季度應繳職業稅稅款: "G.季度應繳職業稅稅款",
  全年應繳職業稅稅款: "G.全年應繳職業稅稅款",
  "(1)計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。":
    "(1)計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。",
  "(2)不足一元的部分，作一元計。": "(2)不足一元的部分，作一元計。",
  "(3)不足一元的部分，作一元計。": "(3)不足一元的部分，作一元計。",
  "B.應繳所得補充稅稅款": "B.應繳所得補充稅稅款",
  "A. 年度之可課稅收益": "A. 年度之可課稅收益",
  "(2)僅適用於2020年度取得的收益。": "(2)僅適用於2020年度取得的收益。",
  "Must greater than or equal to 25000.": "輸入金額必須大於25000",

  simpleVueValidator_required: "必填",
  simpleVueValidator_integer: "輸入值需為整數",
  simpleVueValidator_greaterThenZero: "相關數字不能為負數",
  simpleVueValidator_over_three_million: "超過300萬",
  stamp_duty_transfer: "印花稅（財產之移轉）模擬計算",
  bought_value: "購買價值",
  mop: "澳門幣",
  house_record_value: "房屋記錄價值",
  please_input_int_amt: "請輸入整數金額。",
  confirm_transfer: "確定轉移",
  confirm_middle_transfer: "確定轉移(曾作出中間移轉)",
  from: "由",
  till: "至",
  tax_rate: "稅率",
  tax_amt: "可課稅金額",
  level_tax: "該級稅款",
  sub_tax_amt: "累計稅款",
  property_transfer_stamp_duty: "財產轉移印花稅",
  voucher_stamp_duty: "憑單印花稅",
  total_tax_amt: "應繳稅款總額",
  calculate: "計算",
  ahead_1: "",
  ahead_2: "以上",
  remark_1: "計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。",
  remark_2: "不足一元的部分, 作一元計。",
  remark_3: "對出租房屋可課稅收益適用的稅率為百分之八。",
  remark_3_1: "對非出租房屋可課稅收益適用的稅率為百分之六。",
  transfer_real_estate_stamp_duty: "關於移轉不動產的特別印花稅之模擬計算",
  sale_value: "出售價值",
  calculate_transfer_stamp_duty_from_one_year:
    "於結算財產移轉印花稅之日起計一年內作出移轉",
  calculate_transfer_stamp_duty_from_two_year:
    "於結算財產移轉印花稅之日起計第二年內作出移轉",
  house_tax_calculator: "2020 - 2022年度市區房屋稅之模擬計算",
  house_for_rent: "出租房屋",
  house_not_for_rent: "非出租房屋",
  if_macau_id_holder: "業主是否持有澳門特別行政區居民身份證?",
  please_select: "請選擇",
  yes: "是",
  no: "否",
  real_estate_type: "不動產種類",
  residential: "住宅",
  business: "酒店及同類活動、寫字樓、商業及工業用途",
  other: "其他",
  rent_value: "年租金",
  M7_manage_value: "申報於「房屋稅 - 維修及管理費用 M/7」之金額 : ",
  tax_revenue: "可課稅收益",
  tax: "稅款",
  except_house_tax: "根據有關年度財政預算對市區房屋稅之豁免",
  rent_stamp_duty: "租約印花稅",
  expect_rent_value: "估定年租值",
  company_tax_calculate: "企業所得稅簡要計算表",
  company_type: "企業類型",
  normal_company: "普通企業",
  non_resident_company: "非居民企業",
  high_tech_company: "符合條件在粵澳資企業及高新技術企業",
  low_profit_company: "小型微利企業",
  expect_tax_value: "應納稅所得額",
  expect_personal_tax: "應納個人所得稅",
  personal_tax: "個人所得稅",
  company_tax: "企業所得稅",
  over_one_million: "<=1,000,000部分",
  between_one_million_and_three_million: "1,000,000<應納稅所得額<=3,000,000",
  needed_tax: "所得稅",
  remark: "備註: ",
  remark_6:
    "根據《中華人民共和國企業所得稅法》規定：非居民企業在中國境內未設立機構、場所的，或者雖設立機構、場所但取得的所得與其所設機構、場所沒有實際聯繫的，應當就其來源於中國境內的所得繳納企業所得稅。",
  remark_7:
    "根據《關於實施小型微利企業普惠性所得稅減免政策有關問題的公告》規定：小型微利企業是指從事國家非限制和禁止行業，且同時符合年度應納稅所得額",
  remark_7_1: "不超過300萬元",
  remark_7_2: "、從業人數",
  remark_7_3: "不超過300人",
  remark_7_4: "、資產總額",
  remark_7_5: "不超過5000萬元",
  remark_7_6: "等三個條件的企業。",
  remark_8: "關於小型微利企業的所得稅優惠政策目前有效期至",
  remark_8_1: "2021年12月31日",
  remark_8_2: "。",
  disclaimer1: "以上計算表之應納稅所得額為已經經過納稅調整後",
  disclaimer2:
    "上述計算表不反映當局和執業註冊會計單位之實際課稅/評稅行為，僅供參考",
  personal_tax_calculate: "個人所得稅計算表",
  personal_tax_per_year: "個人所得稅計算表(居民個人綜合所得適用-按年)",
  personal_tax_per_year_non_chinese:
    "個人所得稅計算表(非居民個人綜合所得適用-按月/按次)",
  personal_tax_company: "個人所得稅計算表(經營所得適用)",
  personal_tax_other:
    "個人所得稅計算表(利息、股息、紅利所得,財產租賃所得,財產轉讓所得和偶然所得適用)",
  remark_personal_per_year_1:
    "根據《中華人民共和國企業所得稅法》規定：居民個人綜合所得包括工資、薪金所得、勞務報酬所得、稿酬所得、特許權使用費所得。勞務報酬所得、稿酬所得、特許權使用費所得以收入減除百分之二十的費用後的餘額為收入額。稿酬所得的收入額減按百分之七十計算。",
  remark_personal_1:
    "在中國境內有住所，或者無住所而一個納稅年度內在中國境內居住累計滿一百八十三天的個人，為居民個人。居民個人從中國境內和境外取得的所得，依規定繳納個人所得稅；在中國境內無住所又不居住，或者無住所而一個納稅年度內在中國境內居住累計不滿一百八十三天的個人，為非居民個人。非居民個人從中國境內取得的所得，依法規定繳納個人所得稅。",
  remark_personal_non_chinese:
    "根據《中華人民共和國企業所得稅法》規定：非居民個人取得工資、薪金所得、勞務報酬所得、稿酬所得、特許權使用費所得，按月或者按次分項計算個人所得稅。勞務報酬所得、稿酬所得、特許權使用費所得以收入減除百分之二十的費用後的餘額為收入額。稿酬所得的收入額減按百分之七十計算。",
  remark_personal_disclaimer: "本計算未考慮扣除，計算結果僅供參考。",
  revenue_year: "收入(年度總額)",
  cost_year: "成本(年度總額)",
  expense_year: "費用(年度總額)",
  loss_year: "損失(年度總額)",
  CEL_year: "成本、費用、損失(年度總額)",
  remark_personal_company:
    "個體工商戶的生產、經營所得和對企事業單位的承包經營、承租經營所得適用。",
  unit_RMB: "單位：人民幣",
  dividends: "利息、股息、紅利所得",
  property_for_rent: "財產租賃所得",
  property_for_transfer: "財產轉讓所得",
  property_transfer_revenue: "財產轉讓收入",
  property_origin_amount: "財產原值",
  reasonable_expense: "合理費用",
  incident_income: "偶然所得",
  total: "總計",
  disclaimer_GBP_1:
    "未提及之扣除、免徵、減徵個人所得稅的詳細規定請參照相關政策文件。",
  disclaimer_GBP_2:
    "本計算器計算結果僅供參考。具體申報納稅義務，請依照國家稅收法律、法規、規章及規範性文件的規定執行。",
  disclaimer_GBP_3:
    "上述計算表不反映當局和執業註冊會計單位之實際課稅/評稅行為，僅供參考。",
  total_income_amount: "綜合所得金額",
  salary_income: "工資、薪金所得",
  remuneration_income: "勞務報酬所得",
  manuscript_income: "稿酬所得",
  royalties_income: "特許權使用費所得",
  social_insurance: "各項社會保險金",
  deductions: "專項附加扣除及其他依法確定的扣除",
  per_month: "每月",
  per_time: "每次",
  tax_amount: "應繳稅款",
  register_capital_limit_25000: "註冊資本下限為澳門元MOP$25,000.00，不設上限",
  notarization_fee: "公證手續費",
  notarial_stamp_duty_2021: "公證書印花稅(2021年3月31日生效)",
  registration_certificate_fee: "商業名稱可予登記證明費用(單次)定額MOP 65",
  company_registration: "公司登記",
  main_cost_setup_company: "成立公司主要費用合共約",
  simpleVueValidator_can_divided_by_100: "必須是100的倍數",
  simpleVueValidator_only_year: "請輸入出生日期，格式必須為年/月/日",
  above: "以上",
  incomeTax_discount:
    "根據有關年度財政預算案對所得補充稅稅額之扣減優惠 （稅款扣減額為三十萬元）",
  incomeTax_allYear: "全年應繳所得補充稅稅款（B – C）",
};
